/* import __COLOCATED_TEMPLATE__ from './day-container.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { createDateFromTime, getTimeFromDate } from '@dashboard/shared-ui/utils/availability/availability-period-utils';
import { add } from 'date-fns';
let DayContainer = (_dec = service('availability/availability-periods-manager'), _class = class DayContainer extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "availabilityPeriodsManager", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
  }
  get isDayChecked() {
    return this.args.availabilityPeriods.length > 0;
  }
  toggleIsDayChecked() {
    if (this.isDayChecked) {
      this.availabilityPeriodsManager.deleteAvailabilityPeriodsForDay(this.args.dayOfWeek);
    } else {
      this.availabilityPeriodsManager.addDefaultAvailabilityPeriod(this.args.dayOfWeek, this.args.defaultStartLocalTime, this.args.defaultEndLocalTime);
    }
  }
  copyAvailabilityPeriodToAll(dayOfWeek) {
    this.availabilityPeriodsManager.copyAvailabilityPeriodToAll(dayOfWeek);
  }
  addAvailabilityPeriod(addButtonIndex) {
    const availabilityAtIndex = this.args.availabilityPeriods[addButtonIndex];
    const newStartTime = this.getNextAvailabilityStartTime(availabilityAtIndex);
    const newEndTime = this.getNextAvailabilityEndTime(newStartTime);
    const availabilityPeriod = this.availabilityPeriodsManager.createAvailabilityPeriod(this.args.dayOfWeek, newStartTime, newEndTime);
    this.availabilityPeriodsManager.addAvailabilityPeriod(addButtonIndex + 1, availabilityPeriod);
  }
  deleteAvailabilityPeriod(id, dayOfWeek) {
    this.availabilityPeriodsManager.deleteAvailabilityPeriod(id, dayOfWeek);
  }
  getNextAvailabilityStartTime(previousAvailabilityPeriod) {
    const previousEndTime = previousAvailabilityPeriod.availabilityPeriodModel.endLocalTime;
    const lastEndDate = createDateFromTime(previousEndTime);

    // if the start date is in the last hour of the day (ie 23:00 onwards), we can't add 1 hour to it
    // because that would take us to next day. Instead, we add 15 minutes.
    const newStartDate = previousEndTime.startsWith('23') ? add(lastEndDate, {
      minutes: 15
    }) : add(lastEndDate, {
      hours: 1
    });
    return getTimeFromDate(newStartDate);
  }
  getNextAvailabilityEndTime(startTime) {
    const lastEndDate = createDateFromTime(startTime);
    const newEndDate = add(lastEndDate, {
      hours: 1
    });
    return getTimeFromDate(newEndDate);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "availabilityPeriodsManager", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "toggleIsDayChecked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleIsDayChecked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyAvailabilityPeriodToAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyAvailabilityPeriodToAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAvailabilityPeriod"), _class.prototype), _class);
export { DayContainer as default };